// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"f8d30922","228":"2f839e84","355":"634eadd6","364":"47b3d169","500":"06c5d3ba","509":"99489f95"}[chunkId] + ".css";
};